"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ANALYTICS_SEPARATOR = exports.ANALYTICS_DATALAYER_EVENTS = void 0;
var ANALYTICS_SEPARATOR = exports.ANALYTICS_SEPARATOR = '|';
var ADD_TO_BASKET = 'addToBasket';
var ADD_TO_BASKET_SUCCESS = 'addtobasketsuccess';
var EMAIL_BACK_IN_STOCK = 'global.emwbisSubmitted';
var EMAIL_PRODUCT_LAUNCH = 'global.nmwplSubmitted';
var QUICK_VIEW_OPENED = 'quickViewOpened';
var QUICK_VIEW_UPDATED = 'quickViewUpdated';
var QUICK_VIEW_CLOSED = 'quickViewClosed';
var ANALYTICS_DATALAYER_EVENTS = exports.ANALYTICS_DATALAYER_EVENTS = {
  ADD_TO_BASKET: ADD_TO_BASKET,
  ADD_TO_BASKET_SUCCESS: ADD_TO_BASKET_SUCCESS,
  EMAIL_BACK_IN_STOCK: EMAIL_BACK_IN_STOCK,
  EMAIL_PRODUCT_LAUNCH: EMAIL_PRODUCT_LAUNCH,
  QUICK_VIEW_OPENED: QUICK_VIEW_OPENED,
  QUICK_VIEW_UPDATED: QUICK_VIEW_UPDATED,
  QUICK_VIEW_CLOSED: QUICK_VIEW_CLOSED
};